import { render, staticRenderFns } from "./custom-field-value.vue?vue&type=template&id=17868a84"
import script from "./custom-field-value.vue?vue&type=script&lang=js"
export * from "./custom-field-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports